import clsx from 'clsx';
import React from 'react';
import DorsiaLogo from '@/assets/images/App_Icon.png';

import styles from './AppDownloadBanner.module.css';

// dorsia.com/download forwards to the branch.io link: App Store on iPhone, Google
// Play on Android, and a QR code on desktop.
const DOWNLOAD_URL = 'https://dorsia.com/download';

type Props = {
  label?: string;
  text: string;
  className?: string;
};

const AppDownloadBanner: React.FC<Props> = ({ label = 'Dorsia app', text, className }) => (
  <section className={clsx(styles.banner, className)} aria-label="Download the Dorsia app">
    <img className={styles.icon} src={DorsiaLogo} alt="" width={40} height={40} />
    <div className={styles.copy}>
      <span className={styles.label}>{label}</span>
      <span className={styles.text}>{text}</span>
    </div>
    <a
      className={styles.button}
      href={DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Download
    </a>
  </section>
);

export default AppDownloadBanner;
